const currentUrl = window.location.href;

const isProductPage = currentUrl.includes('/products/');

const ifCurrentPageIsProductHideGorgias = () => {
  if (isProductPage) {
    const chatOpenButtons = document.querySelectorAll('.gorgias-chat-key-1ju6qu0');
    if (chatOpenButtons.length > 0) {
      chatOpenButtons.forEach(button => {
        button.style.display = 'none';
      });
    }
  }
};

document.addEventListener('DOMContentLoaded', function () {
  const chatOpenButton = document.querySelector('.gorgias-chat-open-button');

  if (chatOpenButton) {
    chatOpenButton.addEventListener('click', showGorgias);
  }
});

const showGorgias = () => {
  const containers = document.querySelectorAll('.gorgias-chat-key-1ju6qu0');

  containers.forEach(container => {
    container.style.display = 'block';
  });
};

const gorgiasObserver = new MutationObserver((mutations) => {
  const targetElements = document.querySelectorAll('.gorgias-chat-key-1ju6qu0');

  if (targetElements.length >= 4) {
    ifCurrentPageIsProductHideGorgias();
    gorgiasObserver.disconnect();
  }
});

gorgiasObserver.observe(document.body, {
  childList: true,
  subtree: true
});